import { render, staticRenderFns } from "./activity-gray.svg?vue&type=template&id=f2f16398"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports